// src/pages/PageNotFound/PageNotFound.tsx
import React from 'react';
import { TdsCard } from '@trv-tds/react';
import './PageNotFound.scss';
import { PAGE_NOT_FOUND } from '../../constants';

const PageNotFound: React.FC = () => {
  return (
    <div className="page-not-found">
      <TdsCard className="page-not-found-card">
        <div className="page-not-found-content">
          <div className="page-not-found-icon">404</div>
          <h1>{PAGE_NOT_FOUND.TITLE}</h1>
          <p className="page-not-found-message">
            {PAGE_NOT_FOUND.MESSAGE}
          </p>
        </div>
      </TdsCard>
    </div>
  );
};

export default PageNotFound;
